export default __webpack_public_path__ + "static/media/logo-extensivo-sao-paulo-2023.6805c4cc.svg";